//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { FacebookSettingsModalActions } from './facebookSettingsModalActions';
import { FACEBOOK_SETTINGS_MODAL_ACTIONS, IFacebookSettingsModalState } from './facebookSettingsModalModel';

const initialState: IFacebookSettingsModalState = {
  flags: {
    isOpen: false,
    isFetchingAvailablePages: false,
    isSavingSelectedPage: false,
  },
  availablePages: {
    byId: {},
    orderedIds: []
  },
  saveSelectedPageError: undefined,
  selectedPageId: undefined,
};

export default function FacebookSettingsModalReducer(
  state: IFacebookSettingsModalState = initialState,
  action: FacebookSettingsModalActions,
): IFacebookSettingsModalState {
  switch (action.type) {
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        flags: {
          ...state.flags,
          isOpen: true,
        },
        saveSelectedPageError: initialState.saveSelectedPageError,
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        flags: {
          ...state.flags,
          isOpen: false,
        },
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.REQUEST_AVAILABLE_PAGES:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailablePages: true,
        },
        availablePages: initialState.availablePages,
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.RECEIVE_AVAILABLE_PAGES_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailablePages: false,
        },
        availablePages: action.availablePages,
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.RECEIVE_AVAILABLE_PAGES_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingAvailablePages: false,
        },
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.SET_SELECTED_PAGE:
      return {
        ...state,
        selectedPageId: action.selectedPageId,
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.REQUEST_SAVE_SELECTED_PAGE:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedPage: true,
        },
        saveSelectedPageError: initialState.saveSelectedPageError,
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.RECEIVE_SAVE_SELECTED_PAGE_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedPage: false,
        },
      };
    case FACEBOOK_SETTINGS_MODAL_ACTIONS.RECEIVE_SAVE_SELECTED_PAGE_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingSelectedPage: false,
        },
        saveSelectedPageError: action.message,
      };
  }
  return state;
}
